import { FC } from "react";
import { map, join, isEmpty } from "lodash-es";

import { Card } from "shared/components";
import { copy } from "shared/assets";
import { getEventSettingsActions, useBandRoute } from "Bands/utils";
import { BAND_PATHS } from "Bands/router";
import { Calendar } from "shared/assets/icons";
import { Spacer } from "shared/layout";
import { BoldText, Icon, IconWithText, MutedText } from "shared/styles";
import { getIcon, ICONS } from "shared/utils";
import { useBandContext, usePermissionsContext } from "Bands/contexts";

const {
  bandSettings: { bandSettingsIds, sidemenu, eventSettings },
} = copy;

export const EventSettings: FC = () => {
  const { pushRoute } = useBandRoute();
  const { eventTypes, ticketAndPassTypes, infoBlockTypes } = useBandContext();
  const { bandPermissions } = usePermissionsContext();

  const handleEdit = () => {
    pushRoute(BAND_PATHS.EDIT_BAND_SETTINGS_EVENT);
  };

  const actions = bandPermissions.EDIT
    ? getEventSettingsActions({
        handleEdit,
      })
    : [];

  return (
    <Card
      id={bandSettingsIds.event}
      icon={Calendar}
      title={sidemenu.event}
      actions={actions}
      actionDataTestId="event_settings_actions"
    >
      <Spacer size="l">
        {!isEmpty(eventTypes) && (
          <Spacer size="s">
            <>
              <BoldText>{eventSettings.type.title}</BoldText>
              {map(eventTypes, ({ icon, label }, index) => (
                <IconWithText key={index}>
                  <Icon as={getIcon(icon as ICONS)} />
                  <MutedText>{label}</MutedText>
                </IconWithText>
              ))}
            </>
          </Spacer>
        )}
        {!isEmpty(ticketAndPassTypes) && (
          <Spacer size="s">
            <BoldText>{eventSettings.ticketAndPass.title}</BoldText>
            <MutedText>
              {join(
                map(ticketAndPassTypes, ({ label }) => label),
                ", "
              )}
            </MutedText>
          </Spacer>
        )}
        {!isEmpty(infoBlockTypes) && (
          <Spacer size="s">
            <BoldText>{eventSettings.infoBlocks.title}</BoldText>
            {map(infoBlockTypes, ({ icon, label }, index) => (
              <IconWithText key={index}>
                <Icon as={getIcon(icon as ICONS)} />
                <MutedText>{label}</MutedText>
              </IconWithText>
            ))}
          </Spacer>
        )}
      </Spacer>
    </Card>
  );
};
